import React from 'react'
import { Routes, Route, Outlet, useLocation, Navigate } from 'react-router-dom'
import AppraisalCycle from './pages/appraisal-cycle/view/AppraisalCycle'
import AppraisalCycleConfig from './pages/appraisal-cycle-config/view/AppraisalCycleConfig'
import PerformanceDashboard from './pages/performance-dashboard/view/PerformanceDashboard'
import AppraisalCycleDetails from './pages/appraisal-cycle-details/view/AppraisalCycleDetails'
import EvaluationDetails from './pages/evaluation-details/view/EvaluationDetails'
import PerformanceResult from './pages/performance-result/view/PerformanceResult'
import ManageAppraisal from './pages/manage-appraisal/view/ManageAppraisal'
import SubmitForm from './pages/viewForm/view/formSubmit'
import AltManageEval from './pages/manage-evaluation/view/AltManageEval'
import ViewSubmission from './pages/view-submission/view/viewSubmission'
import ViewSubmissionAppraisal from './pages/view-submission/view/viewSubmissionAppraisal'
import Alt2ViewFormAppraisal from './pages/evaluation-details/view/formAlt2Appraisal'
import WorkPersonalityFitAnalysis from './pages/work-personality-fit-analysis/view/WorkPersonalityFitAnalysis'
import AssessmentDashboard from './pages/personality-test-assessment/view/AssessmentDashboard'
import AssessmentQuestions from './pages/personality-test-assessment/view/AssessmentQuestions'
import UpskillProgression from './pages/upskill-progression/view/UpskillProgression'
import OneUpskillProgression from './pages/upskill-progression/components/OneUpskillProgression'
import UpskillProgressionCourseDetail from './pages/upskill-progression/components/UpskillProgressionCourseDetail'

export const PerformanceRoutes = () => {
  const location = useLocation()
  const state = location.state
  return (
    <Routes location={state?.backgroundLocation || location}>
      <Route path="appraisal" element={<Outlet />}>
        <Route index element={<PerformanceDashboard />} />
        <Route path=":id" element={<PerformanceResult />} />
        <Route path="evaluation/:id" element={<SubmitForm />} />
        <Route path="view-result/:id" element={<ViewSubmission />} />
      </Route>
      <Route path="assessment" element={<Outlet />}>
        <Route index element={<AssessmentDashboard />} />
        <Route path="questions" element={<AssessmentQuestions />} />
      </Route>
    </Routes>
  )
}

export const AppraisalRoutes = () => {
  const location = useLocation()
  const state = location.state
  return (
    <>
      <Routes location={state?.backgroundLocation || location}>
        <Route index element={<Navigate to="dashboard" />} /> {/* done */}
        <Route path="dashboard" element={<AppraisalCycle />} />
        <Route path=":id/manage" element={<ManageAppraisal />} /> {/* done */}
        <Route path=":id/manage-evaluation" element={<AltManageEval />} /> {/* done */}
        <Route path="create" element={<AppraisalCycleConfig />} />
        <Route path="details" element={<Outlet />}>
          <Route path=":id" element={<AppraisalCycleDetails />} /> {/* done */}
        </Route>
        <Route path="evaluation" element={<Outlet />}>
          <Route path=":id" element={<EvaluationDetails />} /> {/* done */}
          <Route path=":id/form/preview/:formId" element={<Alt2ViewFormAppraisal />} />
          <Route path=":id/:submissionId/result" element={<ViewSubmissionAppraisal />} />
          {/* done */}
        </Route>
        <Route path="work-personality-fit-analysis" element={<WorkPersonalityFitAnalysis />} />
        <Route path="upskill-progression" element={<UpskillProgression />} />
        <Route path="upskill-progression" element={<Outlet />}>
          <Route path=":id" element={<OneUpskillProgression />} />
          <Route path=":id/:course_id" element={<UpskillProgressionCourseDetail />} />
        </Route>
      </Routes>
    </>
  )
}
